import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SportsPromotionGridWidget" */ './SportsPromotionGridWidget'),
  modules: ['./SportsPromotionGridWidget'],
  loading: () => <div />
});

export default LoadableWidget;
